import React, { useState } from 'react';
import { Box, TextField, Typography, InputLabel } from '@mui/material';

interface EmailInputWithTagsProps {
  label: string;
  emails: string[];
  onEmailsChange: (emails: string[]) => void;
  readOnly?: boolean;
}

const EmailInputWithTags: React.FC<EmailInputWithTagsProps> = ({ label, emails, onEmailsChange,readOnly = false,}) => {
  const [emailInput, setEmailInput] = useState('');

  const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailInput(e.target.value);
    
  };

  const handleEmailKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (readOnly) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const trimmedEmail = emailInput.trim();
      if (trimmedEmail && !emails.includes(trimmedEmail)) {
        onEmailsChange([...emails, trimmedEmail]);
        setEmailInput('');
      }
    }
  };

  const handleRemoveEmail = (emailToRemove: string) => {
    if (readOnly) return;
    onEmailsChange(emails.filter((email) => email !== emailToRemove));
  };

  const handleEmailInputBlur = () => {
    if (readOnly) return;
    if (emailInput.trim()) {
      const splitEmails = emailInput
        .split(/[,;\s]+/) 
        .map((email) => email.trim())
        .filter((email) => email.includes('@') && !emails.includes(email)); 
      if (splitEmails.length > 0) {
        onEmailsChange([...emails, ...splitEmails]);
        setEmailInput('');
      }
    }
  };

  return (
    <Box className="form-group">
      <InputLabel>{label}</InputLabel>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
          border: '1px solid #656565',
          padding: '2px 10px',
          borderRadius: '4px',
          minHeight: '45px',
        }}
      >
        {emails.map((email, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              background: '#292929',
              padding: '0 8px',
              borderRadius: '4px',
              height: '30px',
              gap: '5px',
            }}
          >
            <Typography variant="body2" sx={{ color: '#fff' }}>{email}</Typography>
            {!readOnly && (
  <span className="removeEmail" onClick={() => handleRemoveEmail(email)}>
    &times;
  </span>
)}
          </Box>
        ))}
        {/* <TextField
          placeholder={`Enter ${label.toLowerCase()} email address`}
          size="small"
          value={emailInput}
          onChange={handleEmailInputChange}
          onKeyDown={handleEmailKeyDown}
          onBlur={handleEmailInputBlur}
          fullWidth
          InputProps={{
    disableUnderline: true,
    sx: {
      color: '#fff', //  input text color
      '& input::placeholder': {
        color: '#aaa', // optional
        opacity: 1,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
  }}
          sx={{
  flex: 1,
  minWidth: '120px',
  '& .MuiInputBase-input': {
    color: '#fff', // makes typed text white
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#aaa',
    opacity: 1,
  },
}}
        /> */}
        {!readOnly && (
  <TextField
    placeholder={`Enter ${label.toLowerCase()} email address`}
    size="small"
    value={emailInput}
    onChange={handleEmailInputChange}
    onKeyDown={handleEmailKeyDown}
    onBlur={handleEmailInputBlur}
    fullWidth
    InputProps={{
      disableUnderline: true,
      sx: {
        color: '#fff',
        '& input::placeholder': { color: '#aaa', opacity: 1 },
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      },
    }}
    sx={{
      flex: 1,
      minWidth: '120px',
      '& .MuiInputBase-input': { color: '#fff' },
      '& .MuiInputBase-input::placeholder': { color: '#aaa', opacity: 1 },
    }}
  />
)}
      </Box>
    </Box>
  );
};

export default EmailInputWithTags;
